import { filterInstances, Module } from '@nu-art/ts-common';
import { ModuleFE_Expression, ModuleFE_Value, ModuleFE_Variable, } from '../../../../_entity.js';
class Module_ExpressionPrettierUtils_Class extends Module {
    constructor() {
        super();
    }
    prettifyExpression = (_expr, terms, withOp = true) => {
        _expr = _expr.replace(/[{}]/g, '');
        return this.replaceValuesIndex(_expr, terms, '_id', withOp);
    };
    unPrettifyExpression = (_expr, terms) => {
        return this.replaceValuesIndex(_expr, terms);
    };
    replaceValuesIndex = (_expr, terms, searchedProp, withOp = true) => {
        const allDeps = Module_ExpressionPrettierUtils.findAllDependencies(_expr);
        _expr = allDeps.reduce((expression, foundResults) => {
            switch (foundResults.type) {
                case 'enum':
                    expression = Module_ExpressionPrettierUtils.replaceValues(expression, foundResults.results, searchedProp, withOp);
                    break;
                case 'var':
                    expression = Module_ExpressionPrettierUtils.replaceVars(expression, foundResults.results, searchedProp, withOp);
                    break;
                case 'expr':
                    expression = Module_ExpressionPrettierUtils.replaceExpression(expression, foundResults.results, searchedProp, withOp);
                    break;
                case 'attr':
                    expression = Module_ExpressionPrettierUtils.replaceVarsWithMultiParams(expression, foundResults.results, searchedProp, withOp, 'attr');
                    break;
                case 'precipitating':
                    expression = Module_ExpressionPrettierUtils.replaceVarsWithMultiParams(expression, foundResults.results, searchedProp, withOp, 'precipitating');
                    break;
                case 'relieving':
                    expression = Module_ExpressionPrettierUtils.replaceVarsWithMultiParams(expression, foundResults.results, searchedProp, withOp, 'relieving');
                    break;
                case 'term':
                    expression = this.replaceTerms(expression, foundResults.results, terms);
                    break;
            }
            return expression;
        }, _expr);
        return _expr;
    };
    replaceValues = (expr, results, searchedProp = 'data', withOp = true) => {
        let _expr = expr;
        if (!results.length)
            return _expr;
        results.map((_val) => {
            const value = ModuleFE_Value.cache.find(item => {
                if (searchedProp === '_id')
                    return item._id === _val;
                return item.data?.value?.toLowerCase() === _val.toLowerCase();
            });
            if (value) {
                _val = withOp ? _val : `enum(${_val})`;
                _expr = _expr.replace(_val, searchedProp === '_id' ? value.data?.value : value._id);
            }
        });
        return _expr;
    };
    replaceExpression = (expr, results, searchedProp = 'label', withOp = true) => {
        let _expr = expr;
        if (!results.length)
            return _expr;
        results.map((currExpr) => {
            const expression = ModuleFE_Expression.cache.find(item => item[searchedProp] === currExpr.toLowerCase());
            if (expression) {
                currExpr = withOp ? currExpr : `expr(${currExpr})`;
                const replaceValue = expression[searchedProp === 'label' ? '_id' : 'label'];
                _expr = _expr.replace(currExpr, replaceValue);
            }
        });
        return _expr;
    };
    replaceVars = (expr, results, searchedProp = '_nameInLowercase', withOp = true) => {
        let _expr = expr;
        if (!results.length)
            return _expr;
        results.map((_var) => {
            const variable = ModuleFE_Variable.cache.find(item => item[searchedProp] === _var.toLowerCase());
            if (variable) {
                _var = withOp ? _var : `var(${_var})`;
                _expr = _expr.replace(_var, variable[searchedProp === '_nameInLowercase' ? '_id' : 'name']);
            }
        });
        return _expr;
    };
    replaceVarsWithMultiParams = (expr, results, searchedProp = '_nameInLowercase', withOp = true, type) => {
        let _expr = expr;
        if (!results.length)
            return _expr;
        results.map((variablesString) => {
            let variablesIds = filterInstances(variablesString.split(',').map(_var => {
                return ModuleFE_Variable.cache.find(item => item[searchedProp] === _var.toLowerCase().trim())?.[searchedProp === '_nameInLowercase' ? '_id' : 'name'];
            })).join(',');
            if (!withOp) {
                if (searchedProp === '_id') {
                    const _midExpr = variablesIds.split(',');
                    if (type !== 'attr')
                        _midExpr.splice(_midExpr.length - 1, 0, `${type} factors`);
                    variablesIds = _midExpr.join('.');
                    variablesString = `${type}(${variablesString})`;
                }
            }
            _expr = _expr.replace(variablesString, variablesIds);
        });
        return _expr;
    };
    replaceTerms = (expr, results, terms) => {
        let _expr = expr;
        if (!results.length || !terms)
            return _expr;
        results.map((termStr, index) => {
            const regex = /[TA](\d+)/i;
            let termIndex = termStr.match(regex);
            termIndex = termIndex && termIndex[1] ? parseInt(termIndex[1], 10) : null;
            if (termIndex && terms[termIndex - 1]) {
                _expr = _expr.replace(results[index], terms[termIndex - 1].expression);
            }
            else
                _expr = _expr.replace(results[index], 'Error');
        });
        return _expr;
    };
    findTerms(expr) {
        const pattern = /(T|A)\d+/gi;
        const matches = expr.match(pattern);
        return matches || [];
    }
    findAllDependencies = (_expr) => [
        { results: this.findDependencies(_expr, 'var'), type: 'var' },
        { results: this.findDependencies(_expr, 'enum'), type: 'enum' },
        { results: this.findDependencies(_expr, 'attr'), type: 'attr' },
        { results: this.findDependencies(_expr, 'precipitating'), type: 'precipitating' },
        { results: this.findDependencies(_expr, 'relieving'), type: 'relieving' },
        { results: this.findDependencies(_expr, 'expr'), type: 'expr' },
        { results: this.findTerms(_expr), type: 'term' }
    ];
    findDependencies = (expr, type) => {
        const regex = new RegExp(`${type}\\((.*?)\\)(\\.\\w+)*`, 'g');
        let match;
        const results = [];
        while ((match = regex.exec(expr)) !== null) {
            results.push(match[1]);
        }
        return results;
    };
    extractOperatorsBetweenTerms = (expression) => {
        const regex = new RegExp(/{[^{}]+}/g);
        return expression.replace(regex, ' ').trim().split(/\s+/);
    };
}
export const Module_ExpressionPrettierUtils = new Module_ExpressionPrettierUtils_Class();
//# sourceMappingURL=Module_ExpressionPrettierUtils.js.map